import Cookies from 'js-cookie';

export default function configureGladlyChat({ key, window }) {
  return new Chat(window, key);
}

class Chat {
  constructor(window, key) {
    this.win = window;
    this.key = key;
  }

  start() {
    if (this.started || !this.key) {
      return;
    }

    this.win.gladlyConfig = {
      appId: this.key,
      layerAppEnv: 'staging',
      gladlyCdn: 'https://cdn.gladly.qa',
    };

    this.load();
    this.started = true;
  }

  onboard({ name, email }) {
    let cookie = {
      name,
      email,
      hasOnboarded: !Cookies.get(`gladlyChatSession-${this.key}`),
    };
    Cookies.set(`gladlyChat-${this.key}`, cookie);
  }

  load() {
    if (this.win.gladlyLoaded) {
      return;
    }

    let doc = this.win.document;

    let el = doc.createElement('script');
    el.type = 'text/javascript';
    el.async = true;
    el.src = `//cdn.gladly.qa/gladly/chat-sdk/widget.js?q=${+new Date()}`;

    let a = doc.getElementsByTagName('script')[0];
    a.parentNode.insertBefore(el, a);

    this.win.gladlyLoaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_gladly_chat.js